import React from 'react'
import { useIntl } from 'react-intl'

import FeaturesFooter from '@/components/sections/FeaturesFooter'
import { Layout } from '@/components/layout'
import routes from '@/routes'
import FeaturePageHeader from '@/components/sections/FeaturePageHeader'
import FeatureSection from '@/components/sections/FeatureSection'
import taxPrepHeroImg from '@/assets/tax-prep/tax-prep-hero.png'
import stayOrganizedImg from '@/assets/tax-prep/id2.png'
import checkReceiptsImg from '@/assets/tax-prep/transaction-stream.png'
import fileTaxesImg from '@/assets/integrations/mapping-to-quickbooks.jpg'
import communicateImg from '@/assets/tax-prep/comments.png'

const pageId = 'taxPrep'
const getPageMessageId = id => `pages.${pageId}.${id}`

const sections = [{
  name: 'stayOrganized',
  imgName: 'id2',
  width: 400,
  img: stayOrganizedImg,
},
{
  name: 'checkReceipts',
  imgName: 'transaction-stream',
  width: 500,
  img: checkReceiptsImg,
},
{
  name: 'fileTaxes',
  imgName: 'quickbooks-mapping',
  ctaProps: {
    to: routes.integrations,
    messageId: getPageMessageId('main.fileTaxes.cta'),
    className: 'self-start',
  },
  width: 400,
  img: fileTaxesImg,
},

{
  name: 'communicate',
  imgName: 'comments',
  width: 400,
  img: communicateImg,
},
]

export default function TaxPrepPage() {
  const { formatMessage } = useIntl()
  const getPageMessage = (id) => formatMessage({ id: getPageMessageId(id) })
  return (
    <Layout.Content>

      <FeaturePageHeader
        description={getPageMessage('main.description')}
        heroProps={{
          src: taxPrepHeroImg,
          alt: 'tax-prep-hero',
          width: 700,
          style: { height: 'auto' },
        }}
        subtitle={getPageMessage('main.subtitle')}
        title={getPageMessage('main.title')}
      />
      {sections.map(({ name, imgName, width = 400, img, ...rest }, ix) => (<FeatureSection
        key={name}
        content={formatMessage({ id: getPageMessageId(`main.${name}.p`) },
          { strong: chunks => <strong>{chunks}</strong> })}
        imgProps={{
          src: img,
          alt: imgName,
          width,
          style: { height: 'auto' },
        }}
        rightImage={ix % 2 === 0}
        secondary={ix % 2 === 0}
        title={getPageMessage(`main.${name}.title`)}
        {...rest}
      />))}
      <FeaturesFooter />

    </Layout.Content>
  )
}

TaxPrepPage.layoutProps = {
  pageId,
}
